// Saved scroll offset of the chat channel list. Module-scoped so it survives the Chat view
// remounting between /chat and /chat/:kind/:id. Semantics: the back button restores the
// position (saved when a chat is opened); the Chat menu icon starts at the top (Navbar clears
// the saved value on nav-tab clicks).

let savedListScroll = 0

export const saveChatListScroll = (value: number) => {
  savedListScroll = value
}

export const peekChatListScroll = () => savedListScroll

export const clearChatListScroll = () => {
  savedListScroll = 0
}
